import { Box, styled } from '@mui/material'

const FormHeaderSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    height: theme.spacing(3),
    width: theme.spacing(3)
  }
}))

export default FormHeaderSection
